import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import CardCSS from "../../../../../../library/Card/Card";
import isValidPaiGowSplit from "../CheckCardRanks";

const PaiGowCardsContainer = forwardRef((props, ref) => {
    const [playerFirstHand, setPlayerFirstHand] = useState([])
    const [playerSecondHand, setPlayerSecondHand] = useState([])
    const [playerSecondHandIndex, setPlayerSecondHandIndex] = useState([])
    const [dealerFirstHand, setDealerFirstHand] = useState([])
    const [dealerSecondHand, setDealerSecondHand] = useState([])
    const [originalPlayerCards, setOriginalCards] = useState(null);
    const [isDealt, setIsDealt] = useState(false)
    const [showHands, setShowHands] = useState(false)
    const [allowClick, setAllowClick] = useState(false)
    const [handMessages, setHandMessages] = useState({
        hand1: "",
        hand2: "",
    })
    const playerHandIntervalRef = useRef(null);
    const dealerHandIntervalRef = useRef(null);

    useImperativeHandle(ref, () => ({
        setAllCards,
        setPlayerAllCards,
        setDealerUnsetCards,
        revealDealerCards,
        setAllowClick,
        setHandMessages,
        clearAllCards,
        setIsDealt,
        getPlayerSecondHandCards: () => {
            // if (props.isPlayer) return playerSecondHand
            if (props.isPlayer) return playerSecondHandIndex.map(ele=>`${ele}`)
            else return []
        }
    }))

    const setAllCards = (res) => {
        if (props.isPlayer) {
            setPlayerFirstHand([...res])
            setOriginalCards([...res])
        } else {
            setDealerFirstHand(['-1', '-1', '-1', '-1', '-1'])
            setDealerSecondHand(['-1', '-1'])
        }
    }

    useEffect(() => {
        if (props.isPlayer && playerFirstHand.length > 0) {

            if (playerSecondHand.length === 2) {
                props.setBetBtn("Stand")
                props.setInfoText(props?.language?.stand_btn)
            } else {
                props.setBetBtn("")
                props.setInfoText(props?.language?.select_second_hand)
            }
        }
    }, [playerSecondHand])

    const clearAllCards = () => {
        setPlayerFirstHand([])
        setPlayerSecondHand([])
        setPlayerSecondHandIndex([])
        setDealerFirstHand([])
        setDealerSecondHand([])
        setShowHands(false)
    }

    const setPlayerAllCards = (res) => {
        // console.log("Setting Player Cards");

        // stop any ongoing dealing
        if (playerHandIntervalRef.current) {
            clearInterval(playerHandIntervalRef.current);
        }

        // reset hands
        setPlayerFirstHand([]);
        setPlayerSecondHand([]);
        setPlayerSecondHandIndex([]);
        setOriginalCards(res);
        setIsDealt(false);

        let i = 0;
        playerHandIntervalRef.current = setInterval(() => {
            props?.soundsRef?.current?.cardFallSound?.stop();
            props?.soundsRef?.current?.cardFallSound?.play();
            // console.log(i, res[i]);

            if (i < 7) { // first 5 cards go to first hand 
                setPlayerFirstHand(prev => [...prev, res[i]]);
            }
            i++;
            if (i > res.length) {
                setIsDealt(true);
                clearInterval(playerHandIntervalRef.current);
                playerHandIntervalRef.current = null;
            }
        }, 400);
    };

    const setDealerUnsetCards = (res) => {
        // stop any ongoing dealing first
        if (dealerHandIntervalRef.current) {
            clearInterval(dealerHandIntervalRef.current);
        }

        // reset dealer hands
        setDealerFirstHand([]);
        setDealerSecondHand([]);

        let i = 0;
        dealerHandIntervalRef.current = setInterval(() => {
            props?.soundsRef?.current?.cardFallSound?.stop();
            props?.soundsRef?.current?.cardFallSound?.play();

            if (i < res.length) {
                if (i < 5) {
                    setDealerFirstHand(prev => [...prev, res[i]]);
                } else {
                    setDealerSecondHand(prev => [...prev, res[i]]);
                }
                i++;
            }

            if (i >= 7 || i >= res.length) {
                clearInterval(dealerHandIntervalRef.current);
                dealerHandIntervalRef.current = null;
            }
        }, 400);
    };


    const revealDealerCards = (res) => {
        let i = 0;
        let j = 0;

        const dealerFirstHandInterval = setInterval(() => {
            if (i < res?.dealerCards.length) {
                props?.soundsRef?.current?.dealerCardRevealSound?.stop()
                props?.soundsRef?.current?.dealerCardRevealSound?.play()
                setDealerFirstHand(prev => {
                    const updated = [...prev];
                    updated[i] = res.dealerCards[i];
                    return updated;
                });
                i++;
            } else {
                clearInterval(dealerFirstHandInterval);
            }
        }, 400);

        setTimeout(() => {
            const dealerSecondHandInterval = setInterval(() => {
                if (j < res?.dealerSplit.length) {
                    props?.soundsRef?.current?.dealerCardRevealSound?.stop()
                    props?.soundsRef?.current?.dealerCardRevealSound?.play()
                    setDealerSecondHand(prev => {
                        const updated = [...prev];
                        updated[j] = res.dealerSplit[j];
                        return updated;
                    });
                    j++;
                } else {
                    clearInterval(dealerSecondHandInterval);
                }
            }, 400);
        }, 2000)
    };

    const cardSelection = (e, index) => {
        if (!allowClick) return;
        if (playerSecondHand.length < 2) {
            // Create copies to avoid direct state mutation
            const firstHandCopy = [...playerFirstHand];
            const selectedIndexCard = originalPlayerCards.indexOf(firstHandCopy[index])
            const selectedCard = firstHandCopy.splice(index, 1); // will be an array with 1 item
            const newSecondHand = [...playerSecondHand, ...selectedCard];
            const secondHandIndex = [...playerSecondHandIndex, selectedIndexCard]

            let isValid = true;

            if (playerSecondHand.length === 1) {
                isValid = isValidPaiGowSplit(newSecondHand, firstHandCopy);
            }

            if (isValid) {
                props?.soundsRef?.current?.cardClickSound?.stop()
                props?.soundsRef?.current?.cardClickSound?.play()
                setPlayerFirstHand(firstHandCopy);
                setPlayerSecondHand(newSecondHand);
                setPlayerSecondHandIndex(secondHandIndex);
                setShowHands(true)
            } else {
                // Optionally: handle invalid split (e.g., show an alert, animate card back, etc.)

                props?.soundsRef?.current?.CardInvalidSelectSound?.stop()
                props?.soundsRef?.current?.CardInvalidSelectSound?.play()
                props.setInfoText(props.language.invalid_pai_gow_split || "Second hand cannot be stronger than Highest hand.")
            }
        }

    }

    const cardUnSelection = (e, index) => {
        if (!allowClick) return;
        let secondHandCard = [...playerSecondHand]; // copy to avoid mutating state directly
        let originalCards = [...originalPlayerCards]; // same here
        let secondHandIndex = [...playerSecondHandIndex]
        let removedCard = secondHandCard.splice(index, 1)[0]; // removed card
        let removedIndex = secondHandIndex.splice(index, 1)[0]
        let first;

        if (secondHandCard.length > 0) {
            const cardToMoveBack = secondHandCard[0]; // or whichever logic you want
            const ind = originalCards.findIndex(card => card === cardToMoveBack); // match value
            if (ind !== -1) {
                first = originalCards.splice(ind, 1)[0];
            }
        } else {
            setShowHands(false)
        }

        props?.soundsRef?.current?.cardClickSound?.stop()
        props?.soundsRef?.current?.cardClickSound?.play()
        setPlayerFirstHand([...originalCards]);
        setPlayerSecondHand([...secondHandCard]);
        setPlayerSecondHandIndex([...secondHandIndex])
    }

    return <div id="cardsContainer" className={isDealt ? "dealt" : ""}>
        {/* {props.isPlayer && playerFirstHand?.length === 5 && <span className="highest">Highest</span>}
        {props.isPlayer && playerSecondHand?.length === 2 && <span className="secondHighest">2<sup>nd</sup> Highest</span>}
        {!props.isPlayer && dealerFirstHand?.length >= 5 && <span className="highest">Highest</span>}
        {!props.isPlayer && dealerSecondHand?.length >= 1 && <span className="secondHighest">2<sup>nd</sup> Highest</span>} */}
        <div id="firstHandCards">
            {props.isPlayer ? showHands && <span className="highest">Highest</span> : <span style={dealerFirstHand?.length >= 5 ? { visibility: "visible" } : { visibility: "hidden" }} className="highest">Highest</span>}
            {
                (props.isPlayer ? playerFirstHand : dealerFirstHand)
                    .map((ele, ind) => (
                        <CardCSS
                            key={ind}
                            index={ind}
                            cardTitle={ele}
                            newClassName="paiGowCard"
                            {...((props.isPlayer) ? { clickFn: cardSelection } : {})}
                        />
                    ))
            }
            {handMessages.hand1 && <div id="hand1"><h3>{handMessages.hand1.replaceAll('_', " ")}</h3></div>}
        </div>

        <div id="secondHandCards">
            {props.isPlayer ? showHands && <span className="secondHighest">2<sup>nd</sup> Highest</span> : dealerSecondHand?.length >= 1 && <span className="secondHighest">2<sup>nd</sup> Highest</span>}
            {
                (props.isPlayer ? playerSecondHand : dealerSecondHand)
                    .map((ele, ind) => (
                        <CardCSS
                            key={ind}
                            index={ind}
                            cardTitle={ele}
                            newClassName={"paiGowCard"}
                            {...((props.isPlayer) ? { clickFn: cardUnSelection } : {})}
                        />
                    ))
            }
            {handMessages.hand2 && <div id="hand2"><h3>{handMessages.hand2.replaceAll('_', " ")}</h3></div>}
        </div>
    </div>
})

export default PaiGowCardsContainer